export const PrivacyPolicy = () => (
  <div className="privacy-policy tnm-v1">
    <main className="main">
      <section className="page-hero">
        <div className="page-header">
          <div className="container">
            <h1>Privacy Policy for The Nutritionist MCR.</h1>
          </div>
        </div>
      </section>
      <section className="legal">
        <div className="container">
          <div className="privacy">
            <p>
              This website, www.thenutritionistmcr.com (the “Website” or “Site”)
              provides healthy meal delivery services (the “Services”). This
              Privacy Policy covers how The Nutritionist MCR (“The Nutritionist
              MCR”, “we”) collects, uses and shares Personal Information (“PI”)
              we collect on the Site. PI includes information about you that is
              personally identifying such as your name, email address, home
              address, and phone number and which is not otherwise publicly
              available. PI may include other types of information depending on
              the legal definition of PI that applies in your physical location.
              Only the definition of PI that applies in your location will apply
              to you under this Privacy Policy. Unless otherwise defined in this
              Privacy Policy, terms used in this Privacy Policy have the same
              meanings as in our Terms of Use, accessible at
              www.thenutritionistmcr.com/terms.
            </p>
            <h3>Agreement</h3>
            <p>
              By using this Site or Services, you accept and hereby expressly
              consent to our collection, use, and disclosure of your PI in
              accordance with the terms of this Privacy Policy. This Privacy
              Policy may change from time to time, so please check back
              periodically to check the most recent modification date to ensure
              that you are aware of any changes in our processing of your PI.
              Your continued use of the Site or Services after any changes
              signifies your express consent to any such changes. If you do not
              agree to such changes, you must immediately stop using the Site.
              This Privacy Policy was last modified on March 7th 2021.
              Information Collection and Use; Choice and Consent
            </p>
            <h3>Retention of Your Information</h3>
            <p>
              We will retain your information, including Personal Information,
              as long as you maintain an account with us or as needed to provide
              the Services. We will retain your information, including Personal
              Information, after your account is closed if we believe it is
              necessary to do so, such as for legal compliance purposes, to
              resolve disputes, enforce our agreements or otherwise operate our
              business. We will not sell, distribute or lease your personal
              information to third parties unless we have your permission or are
              required by law to do so. You are legally entitled to request
              details of the personal information which we hold about you, under
              the UK’s Data Protection Act 1998.
            </p>
            <h3>Email Addresses and Promotional Messages</h3>
            <p>
              We collect email addresses of users and their friends that are
              provided to us through the Site or Services. We use these emails
              to send promotional messages about The Nutritionist MCR. You may
              opt out of receiving these emails by following the unsubscribe
              link or instructions provided in any email we send or by
              contacting us.
            </p>
            <h3>When You Book your consultation / Contact Us</h3>
            <p>
              When you book a nutritional consultation via our online
              appointment booking portal or make an enquiry through our Contact
              Us form, we collect your name and email address{' '}
            </p>
            <h3>Social Media Sites and Widgets</h3>
            <p>
              The Site includes Social Media Features from social media sites
              such as Instagram that run on our site. Please note that our Site
              is not sponsored or endorsed by Facebook or any other social media
              website, which are trademarked and owned by third parties and not
              by us. These Features may collect your IP address, which page you
              are visiting on our Site, and may set a cookie to enable the
              Feature to function properly. Social Media Features and widgets
              are either hosted by a third party or hosted directly on our Site.
              Your interactions with these Features are governed by the privacy
              policy of the company providing it and are not covered by this
              Privacy Policy. We will collect any information you give us
              permission to access from social media websites via social media
              authorisation tokens (for example, Facebook).
            </p>
            <h3>Links to Other Sites; Transactions with Third Parties</h3>
            <p>
              The Site may contain links to other sites that are not owned or
              controlled by us. Please be aware that we are not responsible for
              the privacy practices of these other sites. We encourage you to
              review the privacy policies and statements of other sites to
              understand their information practices. Our Privacy Policy applies
              only to information collected by our Site and Services. The
              Nutritionist MCR is not responsible for and will not be a party to
              any transactions between you and a third party provider of
              products, information or services. The Nutritionist MCR does not
              monitor such transactions or ensure the confidentiality of your
              PI, including credit card information, for any third party
              transaction. Any separate charges or obligations you incur in your
              dealings with these third parties linked to The Nutritionist MCR
              Site are solely your responsibility. We will not sell, distribute
              or lease your personal information to third parties unless we have
              your permission or are required by law to do so.
            </p>
            <h3>Information Sharing and Disclosure</h3>
            <p>
              We disclose Personal Information that we collect to third parties
              who provide services that you request. These third parties have
              access to your Personal Information only to perform specific tasks
              on our behalf and are obligated not to disclose or use your
              information for any other purpose. We will disclose your
              information in response to a valid legal process, for example, in
              response to a court order, a subpoena or other legal request for
              information, and/or to comply with applicable legal and regulatory
              reporting requirements. We also may disclose your information in
              response to a law enforcement agency’s request or other request
              for information from the U.K. or other government entities, or
              where we believe it is necessary to investigate, prevent, or take
              action regarding illegal activities, suspected fraud, situations
              involving potential threats to the physical safety of any person,
              or to verify or enforce compliance with the policies governing our
              products and/or services and with applicable laws, or as otherwise
              required or permitted by law or consistent with legal
              requirements. In addition, we may transfer your information to an
              entity or individual that acquires, buys, or a part of The
              Nutritionist MCR, or our other business units.
            </p>
            <h3>Information Choices</h3>
            <p>
              It is always your choice whether or not to provide us with such
              information. If you do provide PI to the Site, you are giving your
              express consent to the collection, use, and disclosure of your PI
              as described in this Privacy Policy. If you choose not to provide
              the requested information you may not be able to access certain
              features or functions of this Site and you will not have access to
              the Services. You may access, change or delete your information at
              any time as described below. You may opt out of receiving any, or
              all, communications from us by following the unsubscribe link or
              instructions provided in any email we send or by contacting us.
            </p>
            <h3>Cookies</h3>
            <p>
              When you visit the Site, we use session “cookies,” a piece of
              information stored on your computer temporarily and deleted from
              the user’s device when the browser is closed, to allow us to
              uniquely identify your browser while you are browsing or
              interacting with the Site. Session cookies also help us confirm
              your identity and are required in order to log into your account.
              We also use cookies to help us improve the Site. If you wish to
              prevent cookies from being used as you navigate our Site, you can
              reset your browser to refuse all cookies and/or indicate when a
              cookie is being sent. Users who disable their web browsers’
              ability to accept cookies will be able to browse the Site, but
              will not be able to access or take advantage of all of the
              features and Services on the Site. We therefore recommend you do
              not block or disable these cookies. To find out more about
              cookies, including how to see what cookies have been sent and how
              to manage, as well as delete them, visit www.allaboutcookies.org.
            </p>
            <h3>Accessing Your Information</h3>
            <p>
              You may access, review or change your PI by contacting us. For
              information on cancelling your account, please see our Terms of
              Use at www.thenutritionistmcr.com.
            </p>
            <h3>Log Data</h3>
            <p>
              We collect information that your browser sends whenever you visit
              our Service (“Log Data”). This Log Data may include information
              such as your computer’s Internet Protocol (“IP”) address, browser
              type, browser version, the pages of our Service that you visit,
              the time and date of your visit, the time spent on those pages and
              other statistics. In addition, we use third party services such as
              Google Analytics that collect, monitor and analyse this type of
              information in order to increase our Service’s functionality.
              These third party service providers have their own privacy
              policies addressing how they use such information.
            </p>
            <h3>Security</h3>
            <p>
              The security of your Personal Information is important to us, and
              we strive to implement and maintain reasonable, commercially
              acceptable security procedures and practices appropriate to the
              nature of the information we store, in order to protect it from
              unauthorised access, destruction, use, modification, or
              disclosure. However, please be aware that no method of
              transmission over the internet, or method of electronic storage is
              100% secure and we are unable to guarantee the absolute security
              of the Personal Information we have collected from you.
            </p>
            <h3>Children’s Privacy</h3>
            <p>
              Our Site is directed to individuals who are the age of majority or
              older in their jurisdiction. We do not knowingly collect
              information from children. If you believe your child has provided
              information to the Site please contact us using the information
              provided below.
            </p>
            <h3>Contact Us</h3>
            <p>
              If you have any questions about this Privacy Policy, please
              contact us.
            </p>
            <h3>Terms of Use</h3>
            <p>
              Please also visit our Terms and Conditions section establishing
              the use, disclaimers, and limitations of liability governing the
              use of our Site and Services at www.thenutritionistmcr.com.
            </p>
          </div>
        </div>
      </section>{' '}
    </main>
  </div>
);
